(function($) {
    window.showGlobalNotification = function(msg, type) {
        $("#GlobalNotification").addClass("is-visible").find('.alert__text').text(msg);
        if(type == 'success'){
          $("#GlobalNotification .notification__alert").attr('alert-type','success');
        }else{
          $("#GlobalNotification .notification__alert").attr('alert-type','warning');
        }
        setTimeout(function() {
            $("#GlobalNotification").removeClass("is-visible");
        }, 3000);
    };

    window.getUrlParams = function() {
      var params = {};
      var queryString = window.location.search.slice(1); // 去掉问号
      var queryArray = queryString.split('&');
  
      queryArray.forEach(function(param) {
          var pair = param.split('=');
          var key = decodeURIComponent(pair[0]);
          var value = decodeURIComponent(pair[1] || ''); // 处理没有值的情况
          params[key] = value;
      });
  
      return params;
    };

    /**
     * 商品价格格式化
     */
    window.formatCurrency = function (amount) {
        var formattedAmount = (amount / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");  // 转换为小数点两位数
        return CurrencySymbol + formattedAmount + ' ';
        // return CurrencySymbol + formattedAmount + ' ' + Currency;
    }

    /**
     * 价格字符串格式化成数值
     */
    window.removeCurrency = function (amountString) {
        var numericString = amountString.replace(/[^0-9.]/g, ''); // 去掉货币符号、空格和货币代码
        numericString = numericString.replace('.', '');  // 去掉小数点
        return parseInt(numericString, 10);  // 将字符串转换为数值
    }
  
    /**
     * 购物车商品保费
     */
    window.productInsurance = {
        // 商品保费变化
        change: function (page) {
            this.calc(page);
        },
        // 商品保费计算
        calc: function (page) {
            fetch('/cart.js').then(response => response.json()).then(cart => {
              
                // 这里的获取到的购物车商品，需要进一步再排除掉保费商品的来才行
                var subtotalOriginalPrice = 0;
                var subtotalPrice = 0;
                cart.items.forEach(item => {
                  if (item.id != this.product_id) {
                      subtotalOriginalPrice = subtotalOriginalPrice + item.original_line_price;
                      subtotalPrice = subtotalPrice + item.final_line_price
                  }
                });

                var insuranceFee = parseInt(subtotalOriginalPrice * this.insurance_rate);

                var foramttedInsuranceFee = formatCurrency(insuranceFee);
                setTimeout(function () {
                  $("#insurance_fee").html(foramttedInsuranceFee);
                }, 300);

                if (page == 'CartPage') {
                    var subtotalObj = (".cart-subtotal__totals-price");
                } else { 
                    var subtotalObj = (".cart-drawer-subtotal__price");
                }

                // 显示保费选项 checkbox
                var insuranceStatus = localStorage.getItem(this.key);  // // 是否选中保费

                if (insuranceStatus == 1) {
                    setTimeout(function () {
                     $("#shipping_insurance").prop("checked", true);
                    }, 300);
                    
                    var subtotal = ((insuranceFee + subtotalPrice) / 100).toFixed(2);
                    var formattedSubtotal = formatCurrency(insuranceFee + subtotalPrice);
                } else {
                    setTimeout(function () {
                     $("#shipping_insurance").prop("checked", false);
                    }, 300);
                    var subtotal = (subtotalPrice / 100).toFixed(2);
                    var formattedSubtotal = formatCurrency(subtotalPrice);
                }

                if (page == 'CartPage') {
                    $("cart-page .kes-pp-message").attr("data-pp-amount", subtotal);
                } else { 
                    $("cart-drawer .kes-pp-message").attr("data-pp-amount", subtotal);
                }
                
                $("#shopping_insurance_option").show();

                setTimeout(function () {
                  $(subtotalObj).html(formattedSubtotal);
                  $(subtotalObj).attr('data-total-price', subtotal);

                  //gtm埋点
                  gtm_showCartDrawer();
                }, 300);
            })
        },
        // 移除购物车的保费产品
        remove: function () {
            fetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                // 遍历购物车，是否存在保费商品
                var qty = 0;
                cart.items.forEach(item => {
                  if (item.id == this.product_id) {
                      // 如果找到匹配的商品，则删除
                      fetch('/cart/change.js', {
                          method: 'POST',
                          headers: {
                              'Content-Type': 'application/json'
                          },
                          body: JSON.stringify({
                              id: this.product_id,
                              quantity: 0
                          })
                      })
                      .then(response => response.json())
                      .then(data => {
                          $('#CartCount span').html(data.item_count);
                          $('.cart-items__header-product-count').html(data.item_count + ' items in your cart');
                      })
                      .catch((error) => {
                          console.error('删除商品失败:', error);
                      });
                  } else {
                      qty = qty + item.quantity;
                  }
                });

              })
              .catch(error => {
                console.error('Error fetching cart:', error);
              });
        },
        show: function (page) {
            this.calc(page);
            $("#shopping_insurance_option").show();
        },
        setDefaultStatus: function () {
            var insuranceStatus = localStorage.getItem(this.key);
            if (insuranceStatus === null) {
                localStorage.setItem(this.key, 1);
            }
        },
        popover: function () {
          $(document).on('click', 'body .shipping_insurance_popover i', function(e) {
            e.preventDefault();
            if($('body .shipping_insurance_popover_con').is(':visible')) {
              $('body .shipping_insurance_popover_con').hide();
            }else{
              $('body .shipping_insurance_popover_con').show();
            }
          });
          $(document).click(function(e) {
            if(!$(e.target).closest('body .shipping_insurance_popover i').length && $('body .shipping_insurance_popover_con').is(':visible')) {
              $('body .shipping_insurance_popover_con').hide();
            }
          });
          $(document).on('click', 'body .shipping_insurance_popover_con', function(e) {
            e.stopPropagation();
          });
        }
    }
    window.productInsurance.insurance_rate = 0.03;   // 商品保费按商品总金额的3%计算
    window.productInsurance.product_id = '45207424270490';  // 后台设置的保费产品ID
    window.productInsurance.key = 'insurance_fee';  // 保费checkbox勾选状态缓存key
    productInsurance.setDefaultStatus();

    /**
     * Paypal pay after message显示 自定义相关逻辑
     */
    window.kesPaypal = {
      ppMessage: function () {
        
      }
    }
  
    $(document).on('click', 'body product-info .product-variant-picker__list label.pill', function(e) {
      if (!$(this).hasClass('selected')) {
        setTimeout(function () {
          var price = $("product-info .product-price__current-price").text().replace(/[^0-9.]/g, "").trim();
          $(".kes-pp-message").attr("data-pp-amount", price);
        },200);
      }
    });
  
    $(document).on('click', 'body quick-view .quick-view__body .product-variant-picker__list label.pill', function(e) {
      if (!$(this).hasClass('selected')) {
        setTimeout(function () {
          var price = $(".quick-view .product-price__current-price").text().replace(/[^0-9.]/g, "").trim();
          $(".kes-pp-message").attr("data-pp-amount", price);
        },200);
      }
    });

  
})(jQuery);

$(function() {
    // 页面加载完毕后的代码
    productInsurance.remove();
    productInsurance.popover();

    setInterval(function () {
      productInsurance.remove();
    }, 3000);
});